import type { IEntryNavigator } from '../observer/IEntryNavigator';
import { mountObserverLayer } from '../observer/mountObserverLayer';
import { entryHashTarget } from './entryHashTarget';

const LISTENER_KEY = '__poEntryHashListener';

/**
 * Підключає екрани входу до роутера застосунку (викликає router.tsx): хеш-адреси прототипу (#observe, #register, #login — і під час
 * завантаження, і за hashchange) ведуть на відповідні маршрути, а шар спостерігача монтується поруч із застосунком. Після створення роутера
 * — у наступному завданні, коли i18n і сховище вже налаштовано (App.tsx). Повторний виклик замінює попередній слухач.
 */
export function bindEntry(router: IEntryNavigator): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const holder = window as unknown as Record<string, (() => void) | undefined>;
  const follow = () => {
    const to = entryHashTarget(window.location.hash);
    if (to) void router.navigate(to, { replace: true });
  };
  if (holder[LISTENER_KEY]) window.removeEventListener('hashchange', holder[LISTENER_KEY]);
  holder[LISTENER_KEY] = follow;
  window.addEventListener('hashchange', follow);
  setTimeout(() => {
    follow();
    mountObserverLayer(router);
  }, 0);
}
